module.exports = __webpack_public_path__ + "img/papelEventos1.7eb1159e.png";